<button *ngIf="!isLarge"
  id="btn-fit-to-map-small"
  i18n-fmTooltip="@@S_FIT_TO_MAP"
  fmTooltip="Fit to Map"
  i18n-aria-label="@@S_FIT_TO_MAP"
  aria-label="Fit to Map"
  class="fit-to-map fit-to-map--small"
  a7s-id="live-map-fit-to-map-small"
  (click)="onClick()">
  <mat-icon class="fit-to-map--small__icon mat-icon-size-special"
    svgIcon="ds-ic-fitToMap">
  </mat-icon>
</button>

<button *ngIf="isLarge"
  id="btn-fit-to-map-large"
  a7s-id="live-map-fit-to-map-large"
  class="fit-to-map fab fab-secondary fab-md fit-to-map--large"
  i18n-aria-label="@@S_FIT_TO_MAP"
  aria-label="Fit to Map"
  (click)="onClick()">
  <mat-icon class="fit-to-map--large__icon mat-icon-size-xs"
    svgIcon="ds-ic-fitToMap">
  </mat-icon>
  <span class="fit-to-map__text"
    i18n="@@S_FIT_TO_MAP">FIT TO MAP</span>
</button>
